const snackbarPlugin = {
  install: (Vue, { store }) => {
    if (!store) {
      throw new Error('Please provide vuex store.');
    }

    Vue.prototype.$snackbar = {
      showMessage: function ({
        message = '',
        color = ''
      }) {
        store.commit(
          'showMessage',
          { message, color },
          { root: true }
        );
      }
    };
  },
};
export default snackbarPlugin;